<template>
  <div id="app">
    <!--    <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
// localStorage.setItem(
//   "access_token",
//   "011OVjml2my08h4GbYnl2jdr9G0OVjmKIGHdeIc1RXBQCGqCKq9dbQLDgTG9UYbc"
// );
// localStorage.setItem(
//   "userinfo",
//   JSON.stringify({
//     id: 2,
//     nickname: "乐多~",
//     sex: 2,
//     is_bind: 0,
//     avatar:
//       "https://thirdwx.qlogo.cn/mmopen/vi_32/MvgCPxxm0NLhRPf4VBMdMgYyZibkQyEjicX2CTyk5BU6P2Wg2U4GA482Q2qmHtbnCG4Ona4gNDDLAiaZ4y6xIJ90g/132",
//     mobile: "15236292526",
//     access_token:
//       "011OVjml2my08h4GbYnl2jdr9G0OVjmKIGHdeIc1RXBQCGqCKq9dbQLDgTG9UYbc",
//     expires_in: 86300
//   })
// );
export default {
  name: "App"
};
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
body {
  width: 100%;
  background-size: 100% 100%;
  height: 100%;
  background-color: #ffffff;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
}

.flex-centerCloumn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

input {
  border: none;
  outline: none;
}

.flexcenter {
  width: 100%;
  display: flex;
  align-items: center;
}

.flexAllcenter {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexbetween {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.textfont {
  font-size: 15px;
}

.tiptext {
  font-size: 13px;
  color: #333333;
}

.margintb {
  margin: 10px 0;
}

.margintb1 {
  margin: 20px 0;
}

.paddingtb {
  padding: 10px 0;
  box-sizing: border-box;
}

.paddingtb1 {
  padding: 20px 0;
  box-sizing: border-box;
}

.marginright {
  margin-right: 10px;
}

.maincolor {
  color: #3157a3;
}

.tipcolor {
  color: #a3a3a3;
}

.tipcolor1 {
  color: #666666;
}

.marginbottom {
  margin-bottom: 10px;
}

.marginbottom1 {
  margin-bottom: 20px;
}

.borderbottom {
  border-bottom: 1px solid #e1e1e1;
}

.beCareful-titlebox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.beCareful-icon {
  width: 4px;
  height: 23px;
  background: #3157a3;
  border-radius: 2px;
  margin-right: 10px;
}

.beCareful-text {
  margin-bottom: 10px;
}

.botton-confirm {
  width: 68px;
  height: 22px;
  background: #3157a3;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #ffffff;
}

.addbotton {
  width: calc(100% - 40px);
  margin: 20px;
  height: 38px;
  background: #3157a3;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #ffffff;
}

.addbotton1 {
  width: calc(100% - 40px);
  position: fixed;
  bottom: 60px;
  margin: 20px;
  height: 38px;
  background: #3157a3;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #ffffff;
}

.none {
  width: 100%;
  height: 60px;
}

.tabstop-list {
  width: 100%;
  background-color: 100%;
  /* margin-bottom: 20px; */
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #ffffff;
  padding-top: 14px;
  border-bottom: 1px solid #f2f2f2;
  position: fixed;
  top: 0;
  /*  box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3); */
}

.tabstop-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 18px;
}

.tab-active {
  color: #000000;
  font-weight: bold;
}

.tab-active:after {
  content: "";
  width: 23px;
  height: 4px;
  background: #3157a3;
  display: block;
  margin-top: 12px;
}

.tab-active1 {
  color: #666666;
  font-weight: bold;
}

.tab-active1:after {
  content: "";
  width: 23px;
  height: 4px;
  background: #ffffff;
  display: block;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue